import Videos from './Videos';
import AuthRole from 'layouts/Dashboard/AuthRole';
//import {CreateVideoForm, EditVideoForm } from './components';

const routes = [

  { path: 'videos', element: <AuthRole role="administrator" isPage><Videos /></AuthRole>},
  //{ path: 'videos/create', element: <AuthRole role="administrator" isPage><CreateVideoForm /></AuthRole>},
  //{ path: 'videos/edit/:id', element: <AuthRole role="administrator" isPage><EditVideoForm /></AuthRole>}

]

  export default routes;